export const ACTION_TYPES = {
  UPDATE_CUSTOMER: 'firstCustomer/UPDATE_CUSTOMER',
  RESET_CUSTOMER: 'firstCustomer/RESET_CUSTOMER',
  ADD_BENEFICIARY: 'firstCustomer/ADD_BENEFICIARY',
  REMOVE_BENEFICIARY: 'firstCustomer/REMOVE_BENEFICIARY',
  UPDATE_BENEFICIARY: 'firstCustomer/UPDATE_BENEFICIARY'
};
